import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";
import ErrorAlert from "./ErrorAlert";

const UndoCancelFileButton = ({fileId, status, price_status}) => {
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();

    const handleCancel = async () => {
        try {
            setLoading(true);
            await axiosInstance.put(`/files/${fileId}/cancel/undo`);
            setLoading(false);
            navigate(`/admin/view-file/${fileId}`);
        } catch (error) {
            setLoading(false);
            if (error.response.status === 400) {
                setErrorMessage(error.response.data.message);
                return;
            }
            setErrorMessage("Something went wrong");
        } finally {
            setShowModal(false);
        }
    };

    return (
        <div>
            {errorMessage && (
                <div>
                    {" "}
                    <ErrorAlert errorMessage={errorMessage}/> <br/>{" "}
                </div>
            )}
            {(price_status &&
                price_status === "UNPAID") && (
                <button
                    onClick={() => setShowModal(true)}
                    disabled={loading}
                    className="w-full text-left px-3 py-2 text-sm rounded hover:bg-gray-100 flex items-center gap-2"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                    >
                        <path
                            fillRule="evenodd"
                            d="M3 4a2 2 0 012-2h10a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V4zm5 4a1 1 0 000 2h4a1 1 0 000-2H8z"
                            clipRule="evenodd"
                        />
                    </svg>
                    Undo cancel
                </button>
            )}
            {showModal && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-6 rounded-lg">
                        <h3 className="text-lg text-black font-semibold">
                            Are you sure you want to undo cancel?
                        </h3>
                        <div className="mt-4 flex gap-4">
                            <button
                                onClick={handleCancel}
                                className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg"
                            >
                                {loading ? "Undoing..." : "Yes"}
                            </button>
                            <button
                                onClick={() => setShowModal(false)}
                                className="bg-gray-300 hover:bg-gray-400 text-black px-4 py-2 rounded-lg"
                            >
                                No
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UndoCancelFileButton;